<template>
  <div class="bg-card-grey mt-3">
    <div class="cardy-body-noBorder">
      <div class="bg-card-grey">
        <h4 class="color-dark-purple mb-3">COMENTÁRIOS</h4>
      </div>
      <div v-for="item in comments" :key="item.id">
        <div>
          <span class="color-dark-purple">
            <strong>{{ item.description }}</strong>
          </span>
        </div>
        <div>
          <span>
            {{ item.recruiter ? "RECRUTADOR(A)" : "GESTOR(A)" }}:
            <span class="color-black">
              {{ item.recruiter ? item.recruiter.name : item.manager.name }}
            </span>
          </span>
        </div>
        <div>
          <hr />
        </div>
      </div>
    </div>
    <div class="pl-3 pr-3 pb-3" v-if="comments.length == 0">
      <span>SEM COMENTÁRIOS ATÉ O MOMENTO</span>
    </div>
  </div>
</template>

<script>
import { dateFilter } from "vue-date-fns";
import { parseISO, formatISO } from "date-fns";
export default {
  props: ["candidate_id"],
  data: () => ({
    comments: [],
  }),
  mounted() {
    axios
      .get(`/recruiters/talent_banks/${this.candidate_id}/candidate/comments`)
      .then((response) => {
        this.comments = response.data.comments;
      });
  },
  filters: {
    date: dateFilter,
  },
};
</script>